module.exports = __webpack_public_path__ + "static/media/RPV_110.96cd6f0a.png";